const BASE_URL = 'https://salomon-live-api.lukuku.co/api';
const NEW_BASE_URL = 'https://slm-event-api.lukuku.co/api';
const BONLOYALTY_BASEURL = 'https://bonloyalty-api.lukuku.co/api/v1';
const MEMBERSHIP_BASEURL = 'https://slm-api.lukuku.co/api';

window.CustomApi = {
  products: async function(productIds) {
    return await fetch(`${BASE_URL}/products`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ productIds: productIds }),
    });
  },

  // login/register/user API

  socialAuth: async function() {
    return await fetch(`${BASE_URL}/social/auth`);
  },

  socialLogin: async function(code, returnTo) {
    return await fetch(`${BASE_URL}/social/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code, returnTo }),
    });
  },

  checkPlusMain: async function(return_url, error_url) {
    return await fetch(`${BASE_URL}/pass/checkplus_main?error_url=${error_url}&return_url=${return_url}`)
  },

  checkPlusSuccess: async function(encodeData) {
    return await fetch(`${BASE_URL}/pass/checkplus_success`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ encodeData: encodeData }),
    });
  },

  checkUser: async function(urlParams) {
    return await fetch(`${BASE_URL}/check-user?${urlParams}`);
  },

  smsOTP: async function(phoneNumber) {
    return await fetch(`${BASE_URL}/sms/otp/send-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber: phoneNumber }),
    });
  },

  users: async function(data) {
    return await fetch(`${BASE_URL}/users`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  },

  // order API

  partialOrderExclusive: async function(payload) {
    return await fetch(`${BASE_URL}/order/partial-order/exclusive`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
  },

  lineItem: async function(type, customerId, orderId, lineItemId) {
    return await fetch(`${BASE_URL}/order/line-item/${type}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId, orderId, lineItemId }),
    });
  },

  lineItemCancel: async function(customerId, orderId, lineItemId) {
    return await fetch(`${BASE_URL}/order/line-item/cancel`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId, orderId, lineItemId }),
    });
  },

  refundStatus: async function(customerId, lineItemIds) {
    return await fetch(`${BASE_URL}/order/line-items?customer_id=${customerId}&line_item_ids=${lineItemIds}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
  },

  requestReturn: async function(customerId, requestReturnItems) {
    return await fetch(`${BASE_URL}/order/line-item/request-return`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId, requestReturnItems }),
    });
  },

  // cart API
  getCart: async function() {
    return await fetch('/cart.js', { cache: 'no-store' });
  },

  renewMembership: async function(customerId) {
    return await fetch(`${BASE_URL}/renew_membership_v3`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId }),
    });
  },

  updateCartV3: async function(customerId, token) {
    return await fetch(`${BASE_URL}/update-cart-v3`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId, cartId:token }),
    });
  },

  productRestockNotification: function(data) {
    return fetch(`${BASE_URL}/product-restock-notification`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  },

  getMembershipGrade: async function(customerId, customerEmail) {
    const today = new Date().toISOString().split('T')[0];
    return await fetch(`${MEMBERSHIP_BASEURL}/me/grade?reference_date=${today}`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'X-Customer-ID': customerId,
        'X-Customer-Email': customerEmail,
        'X-Shop-Domain': 'salomon.co.kr'
      },
    });
  },

  getMembershipCouponList: async function(customerId, customerEmail) {
    const today = new Date().toISOString().split('T')[0];
    return await fetch(`${MEMBERSHIP_BASEURL}/me/coupons?reference_date=${today}`, {
      method: 'GET',
      headers: { 
        'Content-Type': 'application/json',
        'X-Customer-ID': customerId,
        'X-Customer-Email': customerEmail,
        'X-Shop-Domain': 'salomon.co.kr'
      },
    });
  },

  checkPurchaseLimit: async function(productIds, customerId, customerEmail) {
    const ids = Array.isArray(productIds) ? productIds.join(',') : productIds;
    const headers = {
      'Content-Type': 'application/json',
      'X-Shop-Domain': 'salomon-south-korea.myshopify.com',
    };
    if (customerId && customerId !== 'not-found') headers['X-Customer-ID'] = customerId;
    if (customerEmail) headers['X-Customer-Email'] = customerEmail;

    return await fetch(`${MEMBERSHIP_BASEURL}/purchase-limit/check?product_ids=${ids}`, {
      method: 'GET',
      headers,
    });
  },

  // bonloyalty API
  getBonloyaltyCustomer: async function(customerId) {
    return await fetch(`${BONLOYALTY_BASEURL}/customers/${customerId}`, {
      method: 'GET',
      headers: {
        "X-Store-Name": "salomon",
        "X-Shopify-Customer-Access-Token": localStorage.getItem("customerToken"),
      },
    });
  },

  // wishlist API

  createApiWishlist: async function(productID, userID) {
    return await fetch(`${BASE_URL}/likes`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productId: productID, userId: userID }),
    });
  },

  getApiWishlist: async function(userID) {
    return await fetch(`${BASE_URL}/likes?limit=15&user_id=${userID}`);
  },

  getApiWishlistPage: async function(productID, userID) {
    return await fetch(`${BASE_URL}/likes?product_id=${productID}&user_id=${userID}`);
  },

  cancleApiWishlist: async function(productID, userID) {
    return await fetch(`${BASE_URL}/likes/unlike?product_id=${productID}&user_id=${userID}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // event API

  eventParticipant: async function(data) {
    return await fetch(`${BASE_URL}/event-participants`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  },

  eventRaffle: function(data) {
    return fetch(`${BASE_URL}/event-participants/raffle`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  },

  eventRaffleComing: function(data) {
    return fetch(`${BASE_URL}/event-participants/raffle/coming`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  },

  launchingCalenderNotification: function(data) {
    return fetch(`${NEW_BASE_URL}/launching-calendar-notification`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  },



}